import { useScroll } from 'framer-motion';
import {
  _brands,
  _coursesByCategories,
} from 'src/_mock';

import { _testimonials } from '../testimonial/testimonials';

import ScrollProgress from 'src/components/scroll-progress';
import HomeCombination from '../landing/home-combination';
import MarketingServicesInclude from '../landing/marketing-services-include';
import TravelLandingHero from '../landing/career-landing-hero';
import MarketingOurClients from '../landing/marketing-our-clients';

import MarketingLandingAbout from '../landing/marketing-landing-about';
import MarketingLandingCaseStudies from '../landing/marketing-landing-case-studies';
import CareerTestimonial from '../testimonial/career-testimonial';
import MarketingLandingFreeSEO from '../landing/marketing-landing-free-seo';

import _caseStudies from 'src/sections/_z36/casestudy/projects';

import {_services} from './_services';
// ----------------------------------------------------------------------

export default function TravelLandingView() {
  const { scrollYProgress } = useScroll();

  return (
    <>
      <ScrollProgress scrollYProgress={scrollYProgress} />
      <TravelLandingHero />
      <MarketingServicesInclude />
      <MarketingLandingAbout />
      <HomeCombination />
      <MarketingOurClients brands={_brands} />
      <MarketingLandingCaseStudies caseStudies={_caseStudies.slice(0)} />
      <CareerTestimonial testimonials={_testimonials} />
      <MarketingLandingFreeSEO />
    
    </>
  );
}
